import {BaseFilter} from './base.filter';

export class LocationFilter extends BaseFilter {
    name: string;
}

